module.exports = __webpack_public_path__ + "static/img/yy19.98e7be9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/rongyu/yy19.png
// module id = 7sEY
// module chunks = 1